<script setup lang="ts">
import ApocImage from '@src/components/common/ApocImage.vue';
import IconArrowDown from '@src/components/common/icons/IconArrowDown.vue';
import IconLogout from '@src/components/common/icons/IconLogout.vue';
import IconUser from '@src/components/common/icons/IconUser.vue';
import AppConfig from '@src/constants';
import { removeLocalData } from '@src/utils/common-util';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const isUserMenuOpen = ref(false);
const router = useRouter();

const handleOpenUser = () => {
  isUserMenuOpen.value = !isUserMenuOpen.value;
};

const goToList = () => {
  router.replace({ path: '/admin' });
};

const onClickLogout = () => {
  removeLocalData(AppConfig.KEYS.LOGIN_TOKEN);
};
</script>

<template>
  <header>
    <div class="gnb-logo">
      <apoc-image
        class="mr-1 logo-header"
        src="/assets/images/nie_logo.webp"
        @click="goToList"
        style="cursor: pointer;"
      />
    </div>
    <div class="gnb-user" v-on:click="handleOpenUser">
      <p class="nickname text-h7">관리자<icon-arrow-down /></p>
      <span class="user-grade text-c2">최고 관리자</span>
    </div>
    <div
      v-if="isUserMenuOpen"
      class="user-menu box-shadow"
      v-click-away="handleOpenUser"
    >
      <div class="user-title">
        <div class="profile-wrapper">
          <icon-user />
        </div>
        <p class="nickname">
          관리자
          <span class="user-grade text-h7 color-font-sub">최고 관리자</span>
        </p>
      </div>
      <div class="menus">
        <!-- <router-link to="/"><icon-setting /> 내계정 관리</router-link> -->
        <router-link to="/admin/login" @click="onClickLogout">
          <icon-logout />로그아웃
        </router-link>
      </div>
    </div>
  </header>
</template>

<style scoped>
.logo-header {
  max-width: 220px;
}
</style>
